<template>
  <div class="">
    <table class="ui very basic unstackable table">
      <tbody>
        <tr>
          <th class="right aligned">Total del pedido</th>
          <td class="right aligned">
            {{ totalProducts | numeralFormat('$0,0.00') }}
          </td>
        </tr>
        <tr>
          <th class="right aligned">Cargo por embalaje</th>
          <td class="right aligned">
            {{ 10 | numeralFormat('$0,0.00') }}
          </td>
        </tr>
        <tr>
          <th class="right aligned">Costo de envío</th>
          <td class="right aligned">
            {{ shipping.price | numeralFormat('$0,0.00') }}
          </td>
        </tr>
        <tr v-if="isSecured">
          <th class="right aligned">
            <h4 class="ui header">
              Seguro
              <div class="sub header">
                Reembolso en caso de accidente
              </div>
            </h4>
          </th>
          <td class="right aligned">
            {{ insuranceCost | numeralFormat('$0,0.00') }}
          </td>
        </tr>
        <tr>
          <th class="right aligned">Total</th>
          <td class="right aligned">
            <b>{{
              (totalProducts + shipping.price + insuranceCost + 10)
                | numeralFormat('$0,0.00')
            }}</b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';

export default {
  name: 'Summary',
  props: ['shipping', 'isSecured'],
  computed: {
    totalProducts: function() {
      return this.$store.getters['cart/total'];
    },
    insuranceCost: function() {
      if (this.shipping.insuranceType === 'FIXED') {
        return this.shipping.insuranceAmount;
      } else if (this.insuranceType === 'PERCENTAGE') {
        return Math.ceil(this.totalProducts * (this.shipping.percentage / 100));
      } else {
        return 0;
      }
    }
  }
};
</script>

<style></style>
